import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { SecondaryMarketCpOrderForm } from 'state/secondaryMarket/cpOrder/cpOrderForm/input/cpOrderInputForm.model';
import { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { Sales } from 'state/secondaryMarket/shared/referential/referential.model';
import type { Collection } from 'state/utils/types';

export type SalesDesk = {
  desk: string;
};

export type CpOrderSettlementType = {
  settlementType: string;
  marketType: string;
  description?: string;
};

export type CpOrderSettlement = CpOrderSettlementType & {
  isDefaultBuy: boolean;
  isDefaultSell: boolean;
};

export type ClientData = {
  allSales: Sales[] | undefined;
  selectedSale?: Sales;
  settlements: CpOrderSettlement[];
  client?: ISalesCounterpart;
};

export type ClientState = {
  isLoading: boolean;
  data: ClientData | undefined;
  error?: SecondaryMarketFormError<SecondaryMarketCpOrderForm>;
};

export const initialClientState: ClientState = {
  isLoading: false,
  data: undefined,
  error: undefined,
};

export type ClientStateByTabIdMap = Collection<ClientState>;

export const initialClientStateByTabIdMap = {};
